import { INoticeProps } from 'telia-front-react';

export interface BankFormResponse {
  params: {
    formPostUrl?: string;
    redirectData?: Map<string, string>;
  };
}

export interface Notice extends INoticeProps {
  renderedMessage?: string;
  message?: string;
  jsx?: React.ReactNode;
  paramObject?: object;
  erroredFieldIds?: string[];
}

export interface SSOClient {
  handlers: SSoClientHandler[];
}

interface SSoClientHandler {
  action: string;
  callback: (data: any) => void;
  isPromise: boolean;
}

export interface UiResponse {
  panels?: string[];
  errorMessage?: string;
  redirectData?: Map<string, string>;
  component?: string;
  notice?: Notice;
  redirectUrl?: string;
  params?: MergeParams;
}

export interface MergeParams {
  mergeStage?: string;
  mergeAccount?: string;
  confirmOptions?: string | boolean;
  confirmSkipped?: boolean;
  [key: string]: any;
}

export enum AuthService {
  DEALER = 'dealerService',
  // HARD
  DUMMY = 'dummyService',
  SEB = 'sebService',
  SWED = 'swedService',
  NORDEA = 'nordeaIPService',
  COOP = 'kredService',
  LHV = 'lhvService',
  EID = 'eidService',
  MID = 'midService',
  SID = 'sidService',
  // SOFT
  FB = 'fbService',
  GPLUS = 'gplusService',
  LIVE = 'liveService',
  MAIL = 'mailService',
  // OTHER
  ARGOS = 'ArgosService',
  GOOGLE_OIDC = 'googleOidcService',
  MANDATE = 'mandateService',
  VALIDATE = 'validate',
}

export interface MandateCustomer {
  customerId: number;
  displayName: string;
  registrationNumber: string;
  registrationNumberCountryCode: string;
  type: CustomerType;
  orderingIndex: number;
  selected: boolean;
}

export enum CustomerType {
  B2C = 'B2C',
  B2B = 'B2B',
}

export type Segment = 'B2C' | 'B2B';
